import React, {FC, PropsWithChildren, useState, MouseEvent} from 'react';


// mui ...
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useRecoilState, useRecoilValue } from 'recoil';

import { Breakpoint, useTheme } from '@mui/system';
import { Typography, useMediaQuery } from '@mui/material';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { currentUserSessionAtom, colorsAtom  } from 'library/store';


export interface MessageBoxDialogProps  {
    open: boolean;
    title : string;    

    okText: string;
    cancelText: string;

    fullWidth? : boolean;
    maxWidth?: Breakpoint;

    height?: string,

    message: string,


    onCancel: () => void;
    onOk: (event : MouseEvent<HTMLButtonElement>) => void;
    onClose: () => void;
} 

 

type ActionFunc = () => void;

const styles = {
  dialogPaper: {
      minHeight: '80vh',
      maxHeight: '80vh',
  },
};


export function MessageBoxDialog  (props : PropsWithChildren<MessageBoxDialogProps>)  {

    const {isAuthenticated } = useRecoilValue(currentUserSessionAtom);
    const [Colors, setColors] = useRecoilState(colorsAtom);

    const theme = useTheme();
    const isXs = useMediaQuery( theme.breakpoints.up('xs'));
    const isSm = useMediaQuery( theme.breakpoints.up('sm'));
    const isMd = useMediaQuery( theme.breakpoints.up('md'));
    const isLg = useMediaQuery( theme.breakpoints.up('lg'));
    const isXl = useMediaQuery( theme.breakpoints.up('xl'));

    const sz = isXl? 'xl' : isLg? 'lg': isMd? 'md': isSm? 'sm': 'xs';

    const {open, title, okText, cancelText, onOk, onCancel, onClose, fullWidth, maxWidth, height,
      message} = props;
    return (
      <Dialog open={isAuthenticated && open} onClose={onClose} PaperProps={{
        sx: {
         // width: "50%",
          maxHeight: 600,
          height: height || '30vh',
          overflowX: 'hidden'
          //minHeight: 600
          }
        }} //display: 'flex', alignItems: 'center', justifyContent: 'space-between'
          maxWidth={maxWidth?maxWidth:sz} fullWidth={(fullWidth===undefined)?true:fullWidth}>
        <DialogTitle style={{ display: 'flex', alignItems: 'center', paddingTop: '1px', paddingBottom: '1px',  
              justifyContent: 'space-between', minHeight: 'auto', background: Colors.primary, color: theme.palette.getContrastText(Colors.primary) }}>
          <Typography variant="h6">{title}</Typography>
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          <DialogContentText>
              {message}
          </DialogContentText>          
        </DialogContent>
        <DialogActions>
          { cancelText!==''? <Button variant="outlined" onClick={onCancel} sx={{mb:2, ml: 1 }}>{cancelText}</Button>: null }
          { okText !== ''? <Button variant="contained" onClick={onOk} sx={{mb:2, ml: 4 }}>{okText}</Button>: null}
        </DialogActions>
      </Dialog>);    
}

